exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "video{border-radius:5px}.singleColumn{--btn-padding:20px;justify-items:center;grid-column:1/-1;scroll-margin-top:85px}img{margin-top:var(--video-spacing)}.singleColumn *{grid-column:1/-1}.wideColumn{padding-bottom:var(--component-padding)}.wideColumn *{grid-column:1/-1}@media (min-width:62em){.singleColumn *{text-align:center;grid-column:2/span 10}.singleColumn video,.wideColumn *{grid-column:1/-1}}.cta{text-align:center}.cta .vw-button{margin-top:36px;margin-left:auto;margin-right:auto;border-color:#fff!important;color:#fff!important}@media (max-width:74.99em){.learnMore{text-align:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6af786c5","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vuejs/frontend/2023-launch/components/AppSingleColumn.vue
// module id = 3OHs
// module chunks = 4